module.exports = __webpack_public_path__ + "static/img/gri_980039_b07_f05_038_mm.5fa829d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/gri_980039_b07_f05_038_mm.jpg
// module id = vszv
// module chunks = 0